import classNames from "classnames";

import { Typography } from "../typography";

import styles from "./radio.module.scss";
import { RadioProps } from "./radio.types";

const Radio: React.FC<RadioProps> = ({ value, label, checked, className, disabled, theme = "dark", onChange }) => {
  const handleChange = () => {
    onChange(value);
  };

  return (
    <label className={classNames(styles.radioLabel, className)}>
      {label && (
        <Typography color="white" variant="subheadline">
          {label}
        </Typography>
      )}
      <input
        type="radio"
        value={value}
        checked={checked}
        disabled={disabled}
        className={styles.radioInput}
        onChange={handleChange}
      />
      <span className={classNames(styles.customRadio, disabled && styles.disabled, styles[theme])} />
    </label>
  );
};

export { Radio };
